import {FC, useMemo} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Box, Tab, Tabs, useMediaQuery} from '@mui/material';
import {IRoute} from '@/utils/types';
import {ITeamRole, STORAGE_KEY, USER_TYPE} from '@/utils/enums';
import {
	profileTabsAdmin,
	profileTabsMobOrganization,
	profileTabsOrganization,
	profileTabsUser,
	profileUserMembers,
} from './helpers';
import {orgStorage} from '@/utils/services';
import {profileHeaderStyle} from './ProfileHeader.styles';
import {ProfileTabLabel} from '@/utils/enums/profile.enum';
import {useApiInstance} from '@/contexts/ApiInstanceContext';

const ProfileHeader: FC = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const {role: userType} = useApiInstance();
	const organizationRole = orgStorage.get(STORAGE_KEY.ORGANIZATION_ROLE);

	const pathName = location.pathname.split('/').pop();
	const isLaptop = useMediaQuery('(min-width:1200px)');
	const isTablet = useMediaQuery('(min-width:640px) and (max-width:1200px)');

	const activeTab = useMemo(() => {
		switch (pathName) {
			case 'general':
				return ProfileTabLabel.GENERAL;

			case 'notifications':
				return ProfileTabLabel.NOTIFICATIONS;

			case 'billing':
				return ProfileTabLabel.BILLING;

			case 'contributions':
				return ProfileTabLabel.CONTRIBUTIONS;

			case 'team':
				return ProfileTabLabel.TEAM;

			case 'contact-list':
				return ProfileTabLabel.CONTACTS;

			// case 'integration':
			// 	return ProfileTabLabel.INTEGRATIONS;

			default:
				return ProfileTabLabel.GENERAL;
		}
	}, [location.pathname]);

	const tabs = useMemo(() => {
		switch (userType) {
			case USER_TYPE.ADMIN:
				return profileTabsAdmin;

			case USER_TYPE.ORGANIZATION:
				if (organizationRole === ITeamRole.STANDART) return profileUserMembers;
				if (!isLaptop) return profileTabsMobOrganization;
				return profileTabsOrganization;

			case USER_TYPE.USER:
				return profileTabsUser;

			default:
				return profileTabsUser;
		}
	}, [userType]);

	const changeTab = (newTab: IRoute) => () => {
		navigate(newTab.route);
	};

	return (
		<Box sx={profileHeaderStyle.wrapper}>
			{isLaptop || isTablet ? (
				<Tabs value={activeTab} sx={profileHeaderStyle.tabs}>
					{tabs.map((tab: IRoute) => (
						<Tab
							onClick={changeTab(tab)}
							key={tab.title}
							value={tab.title}
							label={<Box>{tab.title}</Box>}
							sx={profileHeaderStyle.tab}
							disableRipple
						/>
					))}
				</Tabs>
			) : null}
		</Box>
	);
};

export default ProfileHeader;
